import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiGetPageVisibility } from '../api';
import PageLoader from '../components/common/PageLoader';

const PageVisibilityContext = createContext({ loading: true, isPageActive: () => true });

export const PageVisibilityProvider = ({ children }) => {
  const [visibility, setVisibility] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    apiGetPageVisibility()
      .then(({ data }) => {
        if (active) setVisibility(data || {});
      })
      .catch(() => {
        // Fail open so a temporary settings request failure does not take down the storefront.
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  const value = useMemo(() => ({
    loading,
    isPageActive: (pageKey) => visibility[pageKey] !== false,
  }), [loading, visibility]);

  return (
    <PageVisibilityContext.Provider value={value}>
      {children}
    </PageVisibilityContext.Provider>
  );
};

export const usePageVisibility = () => useContext(PageVisibilityContext);

export const PageVisibilityGate = ({ pageKey, children }) => {
  const { loading, isPageActive } = usePageVisibility();
  if (loading) return <PageLoader />;
  return isPageActive(pageKey) ? children : <Navigate to="/" replace />;
};
